import Chart from 'react-apexcharts';
import React, { Component, Fragment } from 'react';
import { Grid, Switch, Card, CardContent, Tooltip } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';
import exportOptions from '../chartExportOptions';
const info = <HelpOutline style={{ fontSize: 15 }}/>;

const getNestedValue = (obj, path) => {
  if (!obj || !path) return undefined;

  return path.split('.').reduce((acc, key) => {
    return acc?.[key];
  }, obj);
}

// const durationFromHours = (val) => { 
//   if(!val) return "00:00:00"
//   return durationFromSeconds(val * 60 * 60);
// };
const durationFromMinutes = (val) => { 
  if(!val) return "00:00:00"
  return durationFromSeconds(val * 60);
};
const durationFromSeconds = (val) => { 
  if(!val) return "00:00:00"
  const days =  Math.floor(val / 60 / 60 / 24);
  const hours =  Math.floor(val / 60 / 60 % 24);
  const minutes =  Math.floor((val / 60) % 60);
  const seconds =  Math.round(val % 60);
  if(days)
    return `${days}d ${hours}h ${minutes}m`; // Don't show seconds if there are days, as it gets too granular and often isn't even accurate at that level
  if(seconds > 0)
    if(hours > 0)
      return `${hours}h ${minutes}m ${seconds}s`; // Show seconds only if it is not 0
    else
      return `${minutes}m ${seconds}s`; // Show seconds only if it is not 0

  return `${hours}h ${minutes}m`; // Show hours and minutes for other cases

  //return `${hours > 9 ? hours : "0" +hours}:${minutes>9 ? minutes : "0" + minutes}:${seconds>9 ? seconds : "0" + seconds}`
};

class ChartComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, toggle: false };
  }



  async componentDidMount() {
    const series = [];
    const total = {
      series:[],
      labels:[]
    }
    let formatter = undefined;


    this.props.series.forEach(s => {
      const seriesData = { name: s.name, data: [] };
      const totalValue = getNestedValue(s.total, this.props.seriesKey);
      total.labels.push(s.name);
      total.series.push(totalValue > 0 ? totalValue : 0);

      s.data.forEach(d => {
        seriesData.data.push(getNestedValue(d, this.props.seriesKey));
      });

      // Formatter for ratio data (percents)
      if(this.props.seriesKey.includes("_ratio"))
        formatter = (val) => val ? (val * 100).toFixed(1) + " %" : "0 %";

      // Formatter for minutes data
      if(this.props.seriesKey.startsWith("time."))
        formatter = durationFromMinutes;
      // Formatter for seconds data
      const secondFormatterData = ["video.duration_sum", "video.late_sum", "video.late_avg", "video.join_delta_avg_all"];
      if(secondFormatterData.includes(this.props.seriesKey))
        formatter = durationFromSeconds;

      series.push(seriesData);
    });

    console.log("Chart data to plot", series, total);
    this.setState({ loading: false, series, total, formatter });
  }

  toggleChartType(e) { this.setState({ toggle:!this.state.toggle }); }

  render() {

    if (this.state.loading)
      return null;


    const legend = { 
      position: "bottom",
      itemMargin: {
        horizontal: 0,
        vertical: 0
      },
      formatter: function(seriesName, _opts) {
        const maxLength = 20;
        if(seriesName && seriesName.length > maxLength)
          return seriesName.substring(0, maxLength) + "...";
        return seriesName;
      },
    }

    const tooltip = {
      y: { 
        formatter: (val, { seriesIndex, dataPointIndex, w }) => {
          if(this.props.seriesKey.includes("_ratio") && this.state.formatter)
            return `${this.state.formatter(val)}`;
          if(this.props.seriesKey.includes("_ratio"))
            return `${val}`;
          // val is often RAW in 100% stacked (as you’re seeing)
          const total = w.globals.stackedSeriesTotals?.[dataPointIndex] ?? 0;
          const pct = total ? (val / total) * 100 : 0;
          if(this.state.formatter)
            return `${this.state.formatter(val)} (${pct.toFixed(1)}%)`;
          return `${val} (${pct.toFixed(1)}%)`;
        }} 
    };
    const commonConfig = {
      chart: { animations: { enabled: false }, toolbar: { show: false }, ...exportOptions("Date", "Count") },
      dataLabels: { enabled: false },
      xaxis: { type: "datetime", labels: { show: true }, crosshairs: { width: 1 }, categories: this.props.categories ? this.props.categories : [] },
      legend: { ...legend, position: "bottom", show: true },
      theme: { mode: 'light', palette: 'palette2', },
      markers: { size: 3, strokeColors: '#fff', strokeWidth: 1, shape: "circle", radius: 2, },
      tooltip
    };

    const pieConfig = {
      chart: { animations: { enabled: false }, ...exportOptions("Name", "Value") },
      labels: this.state.total ? this.state.total.labels : [],
      responsive: [{ breakpoint: 480, options: { chart: { width: 200 }, legend: { position: 'bottom' } } }],
      theme: { mode: 'light', palette: 'palette2', },
      yaxis: { labels: { formatter: this.state.formatter } },
      legend
    };
    if(this.state.toggle){
      commonConfig.chart = { ...commonConfig.chart, type: "bar", stacked:true, stackType: '100%' };
      commonConfig.yaxis = { labels: { formatter: (val) => val + " %" } };
    }
    else{
      commonConfig.chart = { ...commonConfig.chart, type: "line", stacked:false, stackType: 'normal' };
      commonConfig.yaxis = { labels: { formatter: this.state.formatter } };
    }
    const chartKey = this.props.seriesKey + commonConfig.chart.type;
    
    return (
      <Fragment >
        <Card className="card-box mb-4">
          <CardContent style={{width:"100%"}}>
            <Grid container spacing={1}>
              <Grid item xs={9}>
                <div className="d-flex align-items-start">
                  <Tooltip title={this.props.tooltip ? this.props.tooltip : "No tooltip available for " + this.props.title}>
                    <div className=" font-weight-bold font-size-xl text-uppercase" >{this.props.title}</div>
                  </Tooltip>
                </div>
              </Grid>
              <Grid item xs={3} style={{ display: "flex", justifyContent: "flex-end" }}>
                <div className="d-flex align-items-start">
                  <Tooltip title="Toggle to show total chart and switch between stacked and non-stacked.">
                    <Switch checked={this.state.toggle} onChange={this.toggleChartType.bind(this)}  />
                  </Tooltip>
                </div>
              </Grid>
              { this.state.toggle ? 
                <Grid item xs={12} md={4}>
                  <div className="d-flex align-items-start">
                    <Tooltip title="Here's the team comparison over the whole time period.">
                      <div className="font-weight-bold mr-3">Total {info}</div>
                    </Tooltip>
                  </div>
                  <Chart key={chartKey + "piechart"} options={pieConfig} series={this.state.total ? this.state.total.series : []} type="pie" height="200"/>
                </Grid>
              : null }
              <Grid item xs={12} md={this.state.toggle ? 8 : 12}>
                <div className="d-flex align-items-start">
                  <Tooltip title="Here you can see a team by team trendline over time.">
                    <div className="font-weight-bold mr-3">Trendline {info}</div>
                  </Tooltip>
                </div>
                <Chart key={chartKey + "trendline"} options={commonConfig} series={this.state.series} type={this.state.toggle ? "bar" : "line"} height="200"/>
              </Grid>
            </Grid>
          </CardContent>
         </Card>
        </Fragment>
    ); // end of return

  } // end of render()

} // end of class

export default ChartComponent
